import React, { useMemo, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Typography
} from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void> | void;
  loading?: boolean;
  customerName?: string;
  phone?: string;
};

const PREDEFINED_REASONS = [
  'No-show / téléphone éteint',
  'Fausse commande',
  'Arnaque COD',
  'Adresse invalide récurrente',
  'Autre'
];

const BanPhoneDialog: React.FC<Props> = ({ open, onClose, onConfirm, loading, customerName, phone }) => {
  const [selected, setSelected] = useState<string>(PREDEFINED_REASONS[0]);
  const [customReason, setCustomReason] = useState<string>('');

  const effectiveReason = useMemo(() => {
    if (selected === 'Autre') {
      return (customReason || '').trim();
    }
    return selected;
  }, [selected, customReason]);

  const canConfirm = effectiveReason.length > 0 && !loading;

  const handleConfirm = async () => {
    if (!canConfirm) return;
    await onConfirm(effectiveReason);
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Bannir le client</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Client: {customerName || '—'} {phone ? `— ${phone}` : ''}
          </Typography>
        </Box>

        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Motif (choisir un motif rapide ou saisir)
        </Typography>

        <ToggleButtonGroup
          color="error"
          exclusive
          fullWidth
          size="small"
          value={selected}
          onChange={(_, val) => val && setSelected(val)}
          sx={{ flexWrap: 'wrap', gap: 1, mb: 2 }}
        >
          {PREDEFINED_REASONS.map((r) => (
            <ToggleButton key={r} value={r} sx={{ flexGrow: 1 }}>
              {r}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        <TextField
          label="Motif (texte libre)"
          placeholder="Ex: Absence répétée, téléphone injoignable..."
          fullWidth
          multiline
          minRows={2}
          value={customReason}
          onChange={(e) => setCustomReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={!!loading}>Annuler</Button>
        <Button onClick={handleConfirm} color="error" variant="contained" disabled={!canConfirm}>
          {loading ? 'Bannissement...' : 'Bannir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BanPhoneDialog;
